import React from 'react';
import DQRulesTable from './DQRulesTable';
import { DQ_DIMENSIONS } from './Config';

const AssetDQRulesTab = ({ currentAsset }) => {
  if (!currentAsset) return null;

  return (
    <div className="space-y-6">
      {/* Dimension Weightage */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
          <div className="w-[5px] h-6 bg-violet-500 rounded mr-3"></div>
          Dimension Weightage
        </h3>
        <div className="grid grid-cols-6 gap-4">
          {DQ_DIMENSIONS.map((dim) => {
            const value = currentAsset.DQInfo?.Weightage?.[dim];

            return (
              <div
                key={dim}
                className="text-center p-4 bg-gray-50 rounded-lg"
              >
                <p className="text-sm text-gray-500 mb-1 capitalize">
                  {dim}
                </p>
                <p className="text-xl font-bold text-blue-600">
                  {value ? `${value}%` : "N/A"}
                </p>
              </div>
            );
          })}
        </div>


      </div>

      {/* Asset Level Rules */}
      <DQRulesTable
        title="Asset Level Rules"
        titleColor="bg-indigo-500"
        rules={currentAsset.DQInfo?.AssetLevelRules || []}
        showArguments={false}
        emptyMessage="No asset level rules defined"
      />

      {/* Column Level Rules */}
      <DQRulesTable
        title="Column Level Rules"
        titleColor="bg-fuchsia-500"
        rules={currentAsset.DQInfo?.ColumnLevelRules || []}
        showArguments={true}
        emptyMessage="No column level rules defined"
      />
    </div>
  );
};

export default AssetDQRulesTab;
